import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20peach%20and%20golden%20abstract%20illustration%20with%20soft%20flowing%20curves%2C%20gentle%20gradient%20from%20warm%20coral%20to%20soft%20cream%2C%20subtle%20manga%20style%20line%20art%20elements%2C%20dreamy%20atmospheric%20lighting%2C%20artistic%20composition%2C%20no%20text%2C%20clean%20minimal%20background&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="蜜桃少年漫画 - 89890漫画网"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center w-full px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 font-bold text-center leading-tight max-w-3xl">
          蜜桃少年漫画大结局
          <span className="block text-2xl md:text-4xl lg:text-5xl mt-2 font-normal text-primary-300">
            免费高清在线阅读
          </span>
        </h1>
        <p className="mt-5 md:mt-6 text-sm md:text-base text-background-200/90 text-center max-w-xl leading-relaxed">
          在89890漫画网畅读蜜桃少年漫画完整大结局，高清画质、流畅翻页，随时随地沉浸于精彩漫画世界
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/comic/1"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-book-open-line text-lg"></i>
            立即阅读大结局
          </Link>
          <Link
            to="/category/lianai"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-medium hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
          >
            浏览更多漫画
          </Link>
        </div>
      </div>
    </section>
  );
}